// @ts-nocheck
import React, { useState } from 'react';
import avatar from '../assets/avatars/avatar1.png';
import resume from '../assets/resume.pdf';
import { motion } from 'framer-motion';
import { FaLinkedin } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';
import { FaInstagramSquare } from 'react-icons/fa';
import { IoMdPin } from 'react-icons/io';
import Modal from 'react-modal';
import ContactForm from './ContactForm';

function Sidebar() {
  const sidebar_variant = {
    hidden: {
      x: '-10vw',
      opacity: 0,
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        delay: 0.1,
        duration: 0.7,
        type: 'spring',
      },
    },
  };

  Modal.setAppElement('#root');

  // var subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <motion.div
      className='sidebar'
      variants={sidebar_variant}
      initial='hidden'
      animate='visible'
    >
      <img src={avatar} alt='avatar' className='sidebar__avatar' />
      <div className='sidebar__name'>
        Emiliano <span>Kosh</span>
      </div>
      <div className='sidebar__item sidebar__title'>Front End Developer</div>
      <a href={resume} download='resume.pdf'>
        <div className='sidebar__item sidebar__resume'>- Download resume -</div>
      </a>
      <figure className='sidebar__social-icons my-2'>
        <a
          href='https://www.linkedin.com/in/emilianokosh-developer/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaLinkedin alt='linkedin' className='sidebar__icon mr-3' />
        </a>
        <a
          href='https://github.com/monsterkosh'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaGithub alt='github' className='sidebar__icon mr-3' />
        </a>
        <a
          href='https://www.instagram.com/monsterkosh'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaInstagramSquare alt='instagram' className='sidebar__icon' />
        </a>
      </figure>
      <div className='sidebar__contact'>
        {/* <div className='sidebar__item sidebar__github'>
          <a href='/'>
            <img src={github} alt='github' className='sidebar__icon mr-3' />
            Github
          </a>
        </div> */}
        <div className='sidebar__location'>
          <IoMdPin alt='location' className='sidebar__icon_pin mr-2' />
          Parana, E.R. Argentina
        </div>
        <div className='sidebar__item'>mnnnkosh@gmail.com</div>
      </div>
      <div className='sidebar__item sidebar__email' onClick={openModal}>
        Contact me
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        contentLabel='Example Modal'
        className='sidebar__modal'
      >
        <ContactForm closeModal={closeModal} />
      </Modal>
    </motion.div>
  );
}

export default Sidebar;
